import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../src/constants/premissions'
import { insureSearchSchema, healthQueryOptions } from '../../src/schemas/routeSchemas'
import { requirePermission } from '../../src/utils/routePermissions'

export const Route = createFileRoute('/insure')({
  validateSearch: (search) => insureSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    permissionRequired: PERMISSION_ROLES.INSURE,
    layout: 'menu',
  },
})
